import { __awaiter as l, __generator as c, __assign as f } from "./index11.js";
import { fetch as v } from "./index32.js";
import { version as m } from "./index20.js";
var d = function(i, e, t) {
  var r = e.reduce(function(n, s) {
    var u = s.split(":"), a = u[0], o = u[1];
    return n[a] = o, n;
  }, {});
  return {
    type: "Counter",
    metric: i,
    value: 1,
    tags: f(f({}, r), { library: "analytics.js", library_version: "npm:next-".concat(m) })
  };
};
function h(i) {
  console.error("Error sending segment performance metrics", i);
}
var g = (
  /** @class */
  function() {
    function i(e) {
      var t = this, r, n, s, u;
      if (this.host = (r = e?.host) !== null && r !== void 0 ? r : "api.segment.io/v1", this.sampleRate = (n = e?.sampleRate) !== null && n !== void 0 ? n : 1, this.flushTimer = (s = e?.flushTimer) !== null && s !== void 0 ? s : 30 * 1e3, this.maxQueueSize = (u = e?.maxQueueSize) !== null && u !== void 0 ? u : 20, this.queue = [], this.sampleRate > 0) {
        var a = !1, o = function() {
          a || (a = !0, t.flush().catch(h), a = !1, setTimeout(o, t.flushTimer));
        };
        o();
      }
    }
    return i.prototype.increment = function(e, t) {
      if (e.includes("analytics_js.") && t.length !== 0 && !(Math.random() > this.sampleRate) && !(this.queue.length >= this.maxQueueSize)) {
        var r = d(e, t);
        this.queue.push(r), e.includes("error") && this.flush().catch(h);
      }
    }, i.prototype.flush = function() {
      return l(this, void 0, void 0, function() {
        var e = this;
        return c(this, function(t) {
          switch (t.label) {
            case 0:
              return this.queue.length <= 0 ? [
                2
                /*return*/
              ] : [4, this.send().catch(function(r) {
                h(r), e.sampleRate = 0;
              })];
            case 1:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, i.prototype.send = function() {
      return l(this, void 0, void 0, function() {
        var e, t, r;
        return c(this, function(n) {
          return e = { series: this.queue }, this.queue = [], t = { "Content-Type": "text/plain" }, r = "https://".concat(this.host, "/m"), [2, v(r, {
            headers: t,
            body: JSON.stringify(e),
            method: "POST"
          })];
        });
      });
    }, i;
  }()
);
export {
  g as RemoteMetrics
};
//# sourceMappingURL=index57.js.map
